/**
 * @fileoverview POST handler for the "/users/subscription_groups/update_archived_state/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupsUpdateArchivedStateIdCacheKeys } from "./constants";
import type {
  PostUsersSubscriptionGroupsUpdateArchivedStateIdProps,
  UsersSubscriptionGroupsUpdateArchivedStateIdResult,
} from "./types";

export const postUsersSubscriptionGroupsUpdateArchivedStateId = reactQueryMutationAdapter(
  usersSubscriptionGroupsUpdateArchivedStateIdCacheKeys,
  (
    props: PostUsersSubscriptionGroupsUpdateArchivedStateIdProps
  ): Promise<UsersSubscriptionGroupsUpdateArchivedStateIdResult> => {
    return fetch(`/users/subscription_groups/update_archived_state/${props.id}`, "POST", props);
  }
);
